import React from "react"
import { Link, graphql } from "gatsby"
import styled from 'styled-components';
import { rhythm } from "../utils/typography";


// Utilities
import kebabCase from "lodash/kebabCase"

// Components
import {AnotherLayout} from '../components/Layout.js'
import BreadCrumb from '../components/BreadCrumbs.js'
import Seo from "../components/seo";

const CategoryDiv = styled.div`
  padding:${rhythm(1)};
  margin:${rhythm(0.5)};
  border-radius:8px;
  border: 1px solid var(--color-gray3);
  :hover{
    border-color:var(--color-gray1);
    background: var(--color-foreground);
  }
`;


const CategoriesPage = ({
  data: {
    allMdx: { group },
  },
  location
}) => (
  <AnotherLayout>
    <Seo
      title="All Categories"
      pathname={location.pathname}
    />
    <div style={{ margin: `${rhythm(4)} 0` }}>
      <div style={{ paddingLeft: rhythm(0.5) }}>
        <BreadCrumb list={['Home']} />
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {group.map(category => (
          <Link key={category.fieldValue} className="nostyle" to={`/categories/${kebabCase(category.fieldValue)}/`}>
            <CategoryDiv >
              <h1>{category.fieldValue}</h1> {category.totalCount} posts
              </CategoryDiv>
          </Link>
        ))}
      </div>
    </div>
  </AnotherLayout>
)


export default CategoriesPage;

export const pageQuery = graphql`
  query {
    allMdx(limit: 2000) {
      group(field: frontmatter___category) {
        fieldValue
        totalCount
      }
    }
  }
`
